
export default {
  getName: (state) => state.name,
  getNextSeqCode: (state) => state.nextSeqCode,

  getCables: (state) => state.cables,
  getLines: (state) => state.lines,
}